import { render } from "./Commerce4.vue?vue&type=template&id=c111da38"
import script from "./Commerce4.vue?vue&type=script&lang=js"
export * from "./Commerce4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__